import { useState, useCallback } from 'react';

//* HOC's
import withDataContext from 'context/consumerHOC/DataConsumer';

//* Components
import Icon from 'components/common/Icon';
import Text from 'components/common/Text';
import Button from 'components/common/Button';
import FormItem from 'components/common/FormItem';
import Container from 'components/common/Container';
import FormInput from 'components/common/FormInput';
import FormContainer from 'components/common/FormContainer';

//* Style
import FormSectionStyle from './style';

//* Trans
import staticTranslations from "./staticTranslations.json"

const FormSection = ({ pageId, title, description, staticLang, formSection }) => {
    //! Trans
    const trans = staticTranslations[staticLang];

    //! States
    const [isSend, setIsSend] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    //! Handle Finish
    const onFinish = useCallback(
        (values) => {
            setIsSend('loading');

            return formSection({
                ...values,
                subscribed: isChecked,
                landing_id: pageId,
            })
                .then(() => {
                    setIsSend(true);

                    setTimeout(() => {
                        setIsSend(false);
                    }, 3000);
                })
                .catch((err) => {
                    setIsSend(false);

                    return Promise.reject(err);
                });
        },
        [isChecked, pageId]
    );

    return (
        <FormSectionStyle>
            <Container>
                <div className='landing-form-block'>
                    <Text
                        tag={`h1`}
                        className={`landing-form-title h4 font-ping-medium`}
                        text={title}
                    />

                    {description ? (
                        <Text
                            tag={`h2`}
                            className={`landing-form-subtitle p pS font-ping-medium`}
                            text={description}
                        />
                    ) : null}

                    {isSend && isSend !== 'loading' ? (
                        <div className='success-container'>
                            {/* <div className='success-panel'>
								<Icon
									name={'check'}
									className={'success-icon'}
								/>
							</div> */}
                            <div className='success-panel-text'>
                                <Text
                                    className={'h6 font-ping-medium'}
                                    text={trans.successTitle}
                                />
                                <Text
                                    className={'pS font-ping-medium'}
                                    text={trans.successSubtitle}
                                />
                            </div>
                        </div>
                    ) : null}

                    <FormContainer
                        onFinish={onFinish}
                        className={'landing-form-form'}>
                        <Container
                            row
                            full>
                            <FormItem
                                name={'name'}
                                // className={'col-6 col-m-12'}
                                required={false}
                                rules={[{}, { required: true, message: trans.nameRequired }]}
                            >
                                <FormInput
                                    type={'text'}
                                    placeholder={`${trans.name}*`}
                                />
                            </FormItem>

                            <FormItem
                                name={'surname'}
                                // className={'col-6 col-m-12'}
                                required={false}
                                rules={[{}, { required: true, message: trans.surnameRequired }]}>
                                <FormInput
                                    type={'text'}
                                    placeholder={`${trans.surname}*`}
                                />
                            </FormItem>

                            <FormItem
                                name={'email'}
                                required={false}
                                rules={[
                                    {},
                                    { required: true, message: trans.emailRequired },
                                    { type: 'email', message: trans.typeEmail }
                                ]}>
                                <FormInput
                                    type={'email'}
                                    placeholder={`${trans.email}*`}
                                />
                            </FormItem>

                            <FormItem
                                name={'city'}
                                required={false}
                                rules={[{}, { required: true, message: trans.cityRequired }]}>
                                <FormInput
                                    type={'text'}
                                    placeholder={`${trans.city}*`}
                                />
                            </FormItem>

                            <FormItem
                                name={'country'}
                                required={false}
                                rules={[{}, { required: true, message: trans.countryRequired }]}>
                                <FormInput
                                    type={'text'}
                                    placeholder={`${trans.country}*`}
                                />
                            </FormItem>
                            <div
                                className='checkbox-warp'
                                onClick={() => setIsChecked(!isChecked)}>
                                <div className={`checkbox ${isChecked ? 'active' : ''}`}>
                                    {isChecked && (
                                        <Icon
                                            name={'check'}
                                            className={'check-icon'}
                                        />
                                    )}
                                </div>

                                <Text
                                    className={'pXS font-helvetica'}
                                    text={trans.subscribeText}
                                />
                            </div>
                            <Button
                                icon='arrow'
                                text={trans.btnText}
                                type='icon-aside'
                                className='landing-form-btn'
                                disabled={isSend === 'loading'}
                                isBtnLoad={isSend === 'loading'}
                            />
                        </Container>
                    </FormContainer>
                </div>
            </Container>
        </FormSectionStyle>
    );
};

export default withDataContext(FormSection, ['formSection']);
